import './stickyAddToCart.scss';

const SELECTOR_STICKY_CONTAINER = 'sticky-cart';

const scrollFunction = function onscrollChange() {
  if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 150) {
    document.querySelector(`#${SELECTOR_STICKY_CONTAINER}`).style.display = "block";
  } else {
    document.querySelector(`#${SELECTOR_STICKY_CONTAINER}`).style.display = "none";
  }
};

const onStickySizeChange = function onProductStickySizeChange(ev, type = 'js-size') {
  const sizeEl = ev.currentTarget;
  const val = sizeEl.options[sizeEl.selectedIndex].value;

  const desktopTargetSize = document.querySelector(`.${type}[value="${val}"]`);
  const mobileTargetSize = document.querySelector(`.${type}Mobile`);
  // sync sizes select with the main product info
  if (desktopTargetSize) {
    desktopTargetSize.checked = true;
    const e = new Event("change");
    desktopTargetSize.dispatchEvent(e);
  }

  if (mobileTargetSize) {
    mobileTargetSize.value = val;
    const e = new Event("change");
    mobileTargetSize.dispatchEvent(e);
  }

  if (val) {
    // Disable first option [label]
    sizeEl.options[0].disabled = true;
  }
};

const onStickyTrialSizeChange = function onProductStickyTrailSizeChange(ev) {
  return onStickySizeChange(ev, 'js-trialSize');
};

const onPackStickyChange = function onProductStickyPackChange(ev, type = 'js-pack') {
  // resetCTAError();
  const packEl = ev.currentTarget;
  const stickyCTA = document.querySelector('.sticky-cart__add--price');
  const price = packEl.options[packEl.selectedIndex].getAttribute('data-price')
  if (price && stickyCTA) {
    stickyCTA.innerHTML = price;
  }

  // sync pack select with the main product info
  const val = packEl.options[packEl.selectedIndex].value;
  const targetPack = document.querySelector(`.${type}[value="${val}"]`);

  if(targetPack) {
    targetPack.checked = true;
    const e = new Event("change");
    targetPack.dispatchEvent(e);
  }

  if (val) {
    // Disable first option [label]
    packEl.options[0].disabled = true;
  }
};

const onStickyTrialPackChange = function onProductStickyTrailPackChange(ev) {
  return onPackStickyChange(ev, 'js-trialPack');
};


const bind = function bindStickyCart() {
	window.onscroll = function() {
		scrollFunction()
	};

  [].forEach.call(
    document.querySelectorAll('.js-sizeSticky'),
    (el) => {
      el.addEventListener('change', onStickySizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-packSticky'),
    (el) => {
      el.addEventListener('change', onPackStickyChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialSizeSticky'),
    (el) => {
      el.addEventListener('change', onStickyTrialSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialPackSticky'),
    (el) => {
      el.addEventListener('change', onStickyTrialPackChange);
    },
  );
  
};

const init = function initStickyCart() {
  bind();
	
};

const destroy = function destroyStickyCart() {
  [].forEach.call(
    document.querySelectorAll('.js-sizeSticky'),
    (el) => {
      el.removeEventListener('change', onStickySizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-packSticky, .js-trialPack'),
    (el) => {
      el.removeEventListener('change', onPackStickyChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialSizeSticky'),
    (el) => {
      el.removeEventListener('change', onStickyTrialSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialPackSticky'),
    (el) => {
      el.removeEventListener('change', onStickyTrialPackChange);
    },
  );
}

export default {
  destroy,
  init,
};
